export default __webpack_public_path__ + "static/media/addIcon2.62a338ee.svg";